<template>
  <div class="wia-container">
    <div class="wia-box">
      <h2 class="wia-title">{{config.i18n.wia_title}}</h2>
      <div class="wia-select wia-select--categories">
        <span class="wia-label">{{config.i18n.wia_need_help}} </span>
        <span class="wia-label__strong">{{categorySelected.text}}</span>
        <span class="wia-label__back" v-on:click="back()"> {{config.i18n.wia_back}}</span>
      </div>
      <div class="wia-select wia-select--categories" v-if="modelSelected && modelSelected.sku !== null">
        <span class="wia-label">{{config.i18n.wia_model_name}} </span>
        <span class="wia-label__strong">{{modelSelected.code}}</span>
      </div>
    </div>

    <v-wia-input-auto
      v-if="isFreeSearchEnabled()"
      :groups="groups"
      @input="onInputWIAAuto"
      @select="onSelectWIAAuto"
      @reset="onResetWIAAuto"
    >
    </v-wia-input-auto>

    <div class="wia-box wia-box__light">
      <h2 class="wia-title wia-title__black">{{config.i18n.wia_issue_title}}</h2>
      <div class="wia-issues wia-issues--results">
        <div v-bind:class="{ selected: option.id==issueSelected.id }" v-on:click="selectIssue({ id: option.id, text: option.description })" v-for="option in issueOptions" class="wia-issue-container" v-bind:value="{ id: option.id, text: option.description }" v-bind:key="option.id">
          <span class="wia-issue">{{option.description}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {mapState} from 'vuex'
import {getMetaBrand, getMetaCountry, getMetaStaticByTag} from '@/helpers/seoMetatagInfo'
import wiaInputAuto from '@/components/modules/WIAInputAutocomplete'
import autocompleteMixin from '../mixin/autocompleteMixin'

Vue.component('v-wia-input-auto', wiaInputAuto)

export default {
  name: 'WIAStep1',
  title () {
    return `${this.getQueryStringValue('productLine')} ${this.getMetaBrand()} ${this.getMetaStaticByTag('title')} | ${this.getMetaBrand()} ${this.getMetaCountry()}`
  },
  description () {
    return `${this.getMetaStaticByTag('title')} ${this.getQueryStringValue('productLine')} ${this.getMetaBrand()}: ${this.getMetaStaticByTag('description')}.`
  },
  head: {
    link: [
      {
        rel: 'canonical',
        href: document.location.href + 'step1'
      }
    ]
  },
  canonical () {
    return document.location.href
  },
  meta: {
    name: 'robots',
    content: 'index'
  },
  data () {
    return {
      categorySelected: '',
      modelSelected: '',
      groups: [],
      issueSelected: '',
      issueOptions: [
      ]
    }
  },
  computed: {
    config: function () {
      return this.$store.state.config
    },
    ...mapState({
      errors: state => state.auth.errors
    }),
    detail: function () {
      return this.$store.state.details
    }
  },
  mixins: [autocompleteMixin],
  methods: {
    onSubmit () {
      if (this.issueSelected !== '') {
        this.$store.commit('saveIssueData', {'issue': this.issueSelected})
        this.$router.push({
          name: 'WIAStep2',
          params: {
            issue: this.issueSelected
          },
          query: {
            productLine: this.categorySelected.text,
            product: this.modelSelected.sku,
            macroCat: this.issueSelected.id
          }
        })
        if (window.dataLayer) {
          // window.dataLayer.push({
          //   'event': 'WIAPageView',
          //   'eventAction': document.location.href
          // })
        } else {
          console.log(document.location.href)
        }
      }
    },
    selectIssue (issue) {
      this.issueSelected = issue
      this.onSubmit()
    },
    back () {
      this.$router.push({
        name: 'WIA-Home'
      })
    },
    getMetaBrand () {
      return getMetaBrand(this.$store.state.config.brand.toLowerCase())
    },
    getMetaCountry () {
      return getMetaCountry(this.$store.state.config.brand.toLowerCase(), this.$store.state.config.i18n || {})
    },
    getMetaStaticByTag (tag) {
      return getMetaStaticByTag(tag, this.$store.state.config.brand.toLowerCase(), this.$store.state.config.i18n || {})
    },
    getQueryStringValue (key) {
      // eslint-disable-next-line
      return decodeURIComponent(window.location.href.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"))
    },
    getCategory (categoryCode) {
      // /product_line/{language}
      this.$http.get(this.$store.state.config.endpoint + '/product_line/' + this.$store.state.config.language.toLowerCase()).then(
        result => {
          var category = result.body
          var item = category.findIndex(x => x.description === categoryCode)
          if (item !== -1) {
            this.categorySelected = {'id': category[item].id, 'text': categoryCode}
            return 1
          }
          return -1
        })
    },
    getProduct (productCode) {
      // /models/{q}
      this.$http.get(this.$store.state.config.endpoint + '/models/' + productCode).then(
        result => {
          var products = result.body
          var item = products.findIndex(x => x.model === productCode)
          if (item !== -1) {
            this.modelSelected = {'sku': products[item].id, 'code': productCode}
            return 1
          }
          return -1
        }, error => {
          this.errormsg = error.body
        })
    }
  },
  mounted () {
    window.dataLayer = window.dataLayer || []
    // window.dataLayer.push({
    //   'event': 'problems_solutions_funnel',
    //   'step': 'step1',
    //   'path': document.location.pathname
    // })
    const stepName = document.querySelector('.wia-autocomplete .wia-title') ? document.querySelector('.wia-autocomplete .wia-title').innerHTML : document.querySelector('.wia-box__light .wia-title').innerHTML
    console.log(stepName)
    const urlParams = new URLSearchParams(window.location.search)
    const itemCategory = urlParams.get('productLine')
    let troubleShootingIssue = ''
    // FUNREQ07
    window.dataLayer.push({
      'event': 'troubleshooting_funnel',
      'step_number': '1',
      'step_name': "What's the problem",
      'troubleshooting_issue': troubleShootingIssue,
      'item_category3': itemCategory
    })
    // Check for category
    if (this.$store.state.details.category) {
      this.categorySelected = this.$store.state.details.category
    } else {
      var categoryCode = this.getQueryStringValue('productLine')
      if (categoryCode.length > 0) {
        this.getCategory(categoryCode)
      }
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'WIAPageView',
          'eventAction': document.location.href
        })
      } else {
        console.log(document.location.href)
      }
    }

    // Check for sku
    if (this.$store.state.details.model !== null) {
      this.modelSelected = this.$store.state.details.model !== null ? this.$store.state.details.model : this.$route.params.model
    } else {
      var sku = this.getQueryStringValue('product')
      if (sku.length > 0) {
        this.getProduct(sku)
      }
    }
    if (this.categorySelected !== null) {
      if (this.modelSelected === null || this.modelSelected === undefined || this.modelSelected === '') {
        this.modelSelected = {'sku': null, 'code': null}
      }
      // /macro_categories/{language}
      this.$http.get(this.$store.state.config.endpoint + '/macro_categories/' + this.$store.state.config.language.toLowerCase()).then(
        result => {
          this.issueOptions = result.body
        })
      if (this.$store.state.details.issue !== null) {
        this.issueSelected = this.$store.state.details.issue
      }
    } else {
      this.categorySelected = {id: '', text: ' '}
      this.$router.push({
        name: 'WIA-Home'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../style/main.scss';

  .wia-issues{
    max-width: 68rem;
    margin: 0 auto;
  }

  .wia-autocomplete{
    display: flex;
    flex-direction: column;
    padding: 5rem 0;
    gap: 1rem;

    @media (min-width: $desktop) {
      .wia-title{
        font-size: 32px;
      }
    }
  }

  .wia-issue-container{
    margin-bottom: 25px;
    border: 1px solid rgba(177,179,182,0.4);
    background: #fff;
    display: block;
    box-sizing: border-box;
    padding: 2.5rem;
    -webkit-transition: all .2s;
    transition: all .2s;
    &:hover{
      color: #fff;
      background: #0090d0;
      cursor: pointer;
    }
    &.selected{
      color: #fff;
      background: #0090d0;
    }
  }

  .brand-theme-hp {
    .wia-issue-container {
      &:hover {
        background: map-get($colors, premium-background-color-hp);
      }

      &.selected {
        color: #fff;
        background: map-get($colors, premium-background-color-hp);
      }
    }
    .wia-title__black{
      text-align: left;
      margin-bottom: 25px;
    }
  }

  .brand-theme-bk {
    .wia-issue-container {
      &:hover {
        background: map-get($colors, main-button-backgroud-bk);
      }

      &.selected {
        color: #fff;
        background: map-get($colors, main-button-backgroud-bk);
      }
    }
    .wia-title__black{
      text-align: left;
      margin-bottom: 25px;
    }
  }

  .brand-theme-mb {
    .wia-issue-container {
      &:hover {
        background: map-get($colors, main-button-background-mb);
      }

      &.selected {
        color: #fff;
        background: map-get($colors, main-button-backgrond-mb);
      }
    }
    .wia-title__black{
      text-align: left;
      margin-bottom: 25px;
    }
  }

  .brand-theme-wp,
  .brand-theme-wp-2020 {
    .wia-issue-container {
      &:hover {
        background: map-get($colors, main-button-backgroud-wp);
      }

      &.selected {
        color: #fff;
        background: map-get($colors, main-button-backgroud-wp);
      }
    }
  }

</style>
